import { Box, Column, Text } from "@hightouch/htui";
import { AgentDefinitionStatus } from "src/graphql";
import { CitationStatusIcon } from "./citation-status";
import { ContextRow } from "./context-row";
import { citedEntryKey } from "./derive-session-context";
import {
  CITATION_STATUS_LABELS,
  CITATION_STATUS_TEXT_COLORS,
  type CitationStatus,
  type ResolvedCitation,
} from "./resolved-citation";

type Props = {
  citations: ResolvedCitation[];
  onSelect: (citation: ResolvedCitation) => void;
};

export const DefinitionList = ({ citations, onSelect }: Props) => (
  <Column as="ul" listStyleType="none" pl={0} gap={1}>
    {sortByStatus(citations).map((citation) => {
      return (
        <li key={citedEntryKey(citation.citedEntry)}>
          <ContextRow
            icon={
              // The status text on the right already names the status. We can hide the icon from assistive tech.
              <Box aria-hidden>
                <CitationStatusIcon status={citation.status} />
              </Box>
            }
            label={citation.content.title}
            rightContent={
              <Box flexShrink={0}>
                <Text
                  size="sm"
                  color={CITATION_STATUS_TEXT_COLORS[citation.status]}
                >
                  {CITATION_STATUS_LABELS[citation.status]}
                </Text>
              </Box>
            }
            onClick={() => onSelect(citation)}
          />
        </li>
      );
    })}
  </Column>
);

const STATUS_ORDER: Record<CitationStatus, number> = {
  [AgentDefinitionStatus.Assumed]: 0,
  [AgentDefinitionStatus.Verified]: 1,
  deleted: 2,
};

const sortByStatus = (citations: ResolvedCitation[]) =>
  [...citations].sort(
    (a, b) => STATUS_ORDER[a.status] - STATUS_ORDER[b.status],
  );
